<template>
    <div>
      <div class="actions row col-lg-12 mb-5 p-0 m-0 justify-content-end">
        <div class="actions-right row col-lg-6 row justify-content-end p-0 m-0">
          <button type="button" class="btn btn-primary" @click="addExperiences">{{ $t('add') }}</button>
        </div>
      </div>
      <SearchBar @search-clicked="searchClicked"></SearchBar>
      <CTableWrapper ref="table" hover striped :caption="$t('experiences')" :items="items" :actions="actions" :pages="pages" :fields="fields" clickable-rows @row-clicked="rowClicked" @action-clicked="actionClicked" @update-requested="updateItemsRequested" :sorter="{external: true}" :sorterValue="sorterValue" @sorter-value-changed="sorterValueChanged" :loading="loading">
      </CTableWrapper>
    </div>
  </template>
   
  <script>
  import { mapState, mapActions } from 'vuex'
  import CTableWrapper from "@/controls/PaginatedTable.vue";
  import SearchBar from "@/controls/SearchBar.vue";
  import router from '@/router';
  import InputGetList from "@/classes/InputGetList";
  import i18n from '@/helpers/i18n';
  import { convertToPascalCase } from "@/helpers/utils.js";
  
  export default {
    components: { CTableWrapper, SearchBar },
    data () {
      return {
        searchText: '',
        itemsPerPage: localStorage.itemsPerPage ?? 10,
        fields: [
          { key: 'title', label: i18n.t('title'), _classes: 'font-weight-bold', sortable: true },
          { key: 'description', label: i18n.t('description'), sortable: true }
        ],
        actions: [
          { key: 'view', label: i18n.t('view') },
          { key: 'remove', label: i18n.t('remove') }
        ],
        sorterValue: { column: 'title', asc: true },
        loading: false
      }
    },
    computed: {
      ...mapState('experiences', ['getExperiencesOutput']),
      ...mapState('experiences', ['deleteExperienceByIdOutput']),
      experiencesInfo: function() {
        return this.getExperiencesOutput ? this.getExperiencesOutput : null;
      },
      items: function()
      {
        return this.experiencesInfo && this.experiencesInfo.data ? this.experiencesInfo.data : [];
      },
      pages: function()
      {
        return this.experiencesInfo ? this.experiencesInfo.totalPages : 1;
      }
    },
    mounted: function()
    {
      this.updateItemsRequested(1, this.itemsPerPage);
    },
    methods: {
      ...mapActions('experiences', ['getExperiences']),
      ...mapActions('experiences', ['deleteExperienceById']),
      rowClicked (item, index) {
        this.$router.push({name: "EditExperience", query: { id: item.id }, params: { name: item.name } });
      },
      actionClicked(item, action){
        switch(action.key)
        {
          case 'view':
          {
            this.$router.push({name: "EditExperience", query: { id: item.id }, params: { name: item.name } });
            break;
          }
          case 'remove':
          {
            if(confirm(this.$i18n.tc('confirmRemove', item.name, { name: item.name }))){
              this.deleteExperienceById(item.id);
            }
            break;
          }
          default:
          {
            throw "The provided action is not supported!"; 
          }
        }
      },
      updateItemsRequested(currentPage, itemsPerPage)
      {
        //Make request
        this.loading = true;
        this.itemsPerPage = itemsPerPage;
  
        var input = new InputGetList(itemsPerPage, currentPage, this.searchText, this.sorterValue.asc ? 1 : 2, convertToPascalCase(this.sorterValue.column));
        
        this.getExperiences(input); 
      },
      addExperiences () 
      {
        router.push({ name: 'AddExperience' });
      },
      searchClicked(searchText)
      {
        this.searchText = searchText;
        this.$refs.table.reset();
  
        this.updateItemsRequested(1, this.itemsPerPage);
      },
      sorterValueChanged(value)
      {
        this.sorterValue = value;
      }    
    },
    watch:
    {
      sorterValue:
      {
        handler: function(val)
        {
          this.updateItemsRequested(1, this.itemsPerPage);
        },
        deep: true // Watch for changes on the properties
      },
      deleteExperienceByIdOutput: function(val)
      {
        this.loading = true;
  
        if(val)
        {
          this.updateItemsRequested(1, this.itemsPerPage);
        }
      },
      getExperiencesOutput: function(val)
      {
        if(val != null)
        {
          this.loading = false;
        }
      }
    }
  }
  </script>
  
  <style>
  th
  {
    border-top: none !important;
  }
  
  tr
  {
    cursor: pointer;
  }
  
  .status-button
  {
    border: none;
    padding: 0;
    text-decoration: underline;
    color: #321fdb;
  }
  </style>
